<div class="mantis-theme row">
    <div class="col-sm-12">
        <div class="card">
            <div class="chat-wrapper">
                <div class="offcanvas-lg offcanvas-start chat-offcanvas" tabindex="-1" id="offcanvas_User_list">
                    <div class="offcanvas-body p-0">
                        <div id="chat-user_list" class="show collapse collapse-horizontal">
                            <div class="chat-user_list">
                                <div class="card-body px-4">
                                    <div class="d-flex align-items-center justify-content-between mb-3">
                                        <h5 class="mb-0 fw-bold">
                                            Direct messages
                                        </h5>
                                        <button class="btn btn-primary btn-sm btn-new-thread" (click)="onNewChatButtonClick()">
                                            <img src="assets/messaging/ic_plus_small_white.svg" alt="" class="btn-new-thread-icon">
                                            New
                                        </button>
                                    </div>
                                    
                                    <div class="d-flex align-items-center gap-2 mb-3">
                                        <div class="form-search position-relative flex-grow-1">
                                            <span class="search-icon">
                                                <img src="assets/common/ic_search.svg" alt="Search">
                                            </span>
                                            
                                            <input type="search" 
                                                   class="form-control" 
                                                   placeholder="Search conversations"
                                                   [(ngModel)]="searchQuery"
                                                   (ngModelChange)="searchQueryStream.next($event)" />

                                            <button type="button"
                                                    class="clear-search"
                                                    *ngIf="searchQuery"
                                                    (click)="clearSearch()">
                                                <img src="assets/common/ic_x.svg" alt="Clear search">
                                            </button>
                                        </div>

                                        <button type="button"
                                                class="btn filter-search-btn"
                                                *ngIf="hasUserTagLists()"
                                                (click)="openFiltersModal()">
                                            <img src="assets/common/ic_filters.svg" alt="Filters">
                                        </button>
                                    </div>

                                    <!-- Applied Tags Section -->
                                    @if (selectedTags.length > 0) {
                                        <div class="applied-tags-section pt-0 mb-3">
                                            <div class="d-flex align-items-baseline justify-content-between">
                                                <h6 class="applied-tags-label mb-0">Applied filters ({{ selectedTags.length }})</h6>
                                                <button type="button" 
                                                        class="btn-link p-0 border-0 bg-transparent text-decoration-underline"
                                                        (click)="clearAllFilters()">
                                                    Clear all
                                                </button>
                                            </div>
                                            
                                            <div class="user-tags d-flex flex-wrap gap-1">
                                                @for (tagId of selectedTags; track tagId) {
                                                    @if (getTagById(tagId)) {
                                                        <span class="applied-tag-pill">
                                                            {{ getTagById(tagId).name }}
                                                            <button type="button"
                                                                    class="btn-remove-tag"
                                                                    (click)="removeTag(tagId)">
                                                                <img src="assets/common/ic_x.svg" alt="Remove">
                                                            </button>
                                                        </span>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    }

                                    <div class="filter-buttons d-flex gap-2 mb-3">
                                        <button class="btn"
                                                type="button"
                                                [ngClass]="{ 'btn-filter-active': !chatStatus }"
                                                (click)="setChatStatus('')">
                                            All
                                        </button>
                                        <button class="btn"
                                                type="button"
                                                [ngClass]="{ 'btn-filter-active': chatStatus === 'unread' }"
                                                (click)="setChatStatus('unread')">
                                            Unread
                                        </button>
                                        <button class="btn"
                                                type="button"
                                                [ngClass]="{ 'btn-filter-active': chatStatus === 'archived' }"
                                                (click)="setChatStatus('archived')">
                                            Archived
                                        </button>
                                        <button class="btn"
                                                type="button"
                                                [ngClass]="{ 'btn-filter-active': chatStatus === 'favorited' }"
                                                (click)="setChatStatus('favorited')">
                                            Favorites
                                        </button>
                                    </div>
                                </div>

                                <div class="chat-thread-list-container">
                                    <div class="card-body py-0 px-0">
                                        <ng-container *ngTemplateOutlet="chatList"></ng-container>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="chat-content">
                    <app-messages-tab 
                        [context]="'chat'"
                        [user]="selectedUserForNewChat ?? selectedChat?.user"
                        [chat]="selectedChat"
                        [userTags]="selectedChat?.user?.tags"
                        [resetTrigger]="resetMessagesTabTrigger"
                        [refreshListOnFlagsChange]="chatStatus === 'favorited' || chatStatus === 'archived'"
                        (messageSent)="onMessageSent($event)"
                        (chatUpdated)="onChatUpdated($event)"
                        (chatCreated)="onChatCreated($event)">
                    </app-messages-tab>
                </div>
                
                @if (selectedChat && !selectedChat.user.roles?.includes('tester')) {
                    <app-user-info-sidebar
                        [userId]="selectedChat.user.id">
                    </app-user-info-sidebar>
                }
                
                <div class="offcanvas-md offcanvas-end chat-offcanvas" tabindex="-1" id="offcanvas_User_info">
                    <div class="offcanvas-header">
                        <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
                    </div>
                    
                    <div class="offcanvas-body p-0">
                        @if (getUser) {
                            <div id="chat-user_info" class="collapse collapse-horizontal">
                                <div class="chat-user_info">
                                    <div class="text-center card-body position-relative pb-0">
                                        <div class="position-absolute end-0 top-0 p-3 d-none d-md-inline-flex">
                                            <a class="avatar avatar-xs btn-link-danger text-danger">
                                                <i class="f-14" antIcon type="close" theme="outline"></i>
                                            </a>
                                        </div>
                                        <ng-container *ngTemplateOutlet="getUserInfo"></ng-container>
                                    </div>
                                    <ng-container *ngTemplateOutlet="personalDetails"></ng-container>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #chatList>
    <div class="list-group list-group-flush">
        @if (conversations.length > 0) {
            @for (chat of conversations; track chat.id) {
                <a href="javascript:"
                class="list-group-item list-group-item-action user-list"
                (click)="onSelectedChat(chat)"
                [ngClass]="{ 'bg-light-primary': chat.id === selectedChat?.id }">
                    <div class="media align-items-center">
                        <div class="user-avatar position-relative">
                            @if (chat.user.avatar) {
                                <img class="avatar-image" src="{{ chat.user.avatar }}" alt="User image" />
                            } @else {
                                <div class="avatar-circle">
                                    <span class="avatar-initials">{{ getInitials(chat.user) }}</span>
                                </div>
                            }
                        </div>
                        
                        <div class="media-body">
                            <div class="d-flex align-items-center justify-content-between mb-1">
                                <div class="d-flex align-items-center">
                                    @if (chat.is_favorited || chat.is_pinned) {
                                        <div class="thread-flags d-flex align-items-center">
                                            @if (chat.is_favorited) {
                                                <img class="thread-flag-icon me-1" src="assets/messaging/ic_favorited.svg" alt="Favorited">
                                            }
                                            @if (chat.is_pinned) {
                                                <img class="thread-flag-icon me-1" src="assets/messaging/ic_pinned.svg" alt="Pinned">
                                            }
                                        </div>
                                    }
                                    <h5 class="mb-0 text-truncate fw-bold">{{ getUserName(chat.user) }}</h5>
                                </div>
                                
                                @if (chat.last_message) {
                                    <span class="last-message-time">
                                        @if (chat.last_message.created_at.substring(0, 10) == today) {
                                            {{ chat.last_message.created_at | dateFormat:'shortTime' }}
                                        } @else if (chat.last_message.created_at.substring(0, 10) == yesterday) {
                                            Yesterday
                                        } @else {
                                            {{ chat.last_message.created_at | dateFormat:'MM/dd/yy' }}
                                        }
                                    </span>
                                }
                            </div>
                            
                            <div class="d-flex align-items-center justify-content-between">
                                <span class="last-message-text text-truncate me-2 d-inline-flex align-items-center gap-1">
                                    {{ getLastMessage(chat) }}
                                </span>
                                <span class="flex-shrink-0">
                                    @if (chat.unread_count > 0) {
                                        <span class="badge bg-primary rounded-pill unread-badge">
                                            {{ chat.unread_count }}
                                        </span>
                                    } @else {
                                        <i class="text-primary f-12" antIcon type="check" theme="outline"></i>
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </a>
            }
            
            @if (showLoadConversations) {
                <div class="text-center py-3">
                    <button class="btn btn-secondary" 
                            type="button"
                            (click)="loadMoreChats()">
                        Load more
                    </button>
                </div>
            }
        } @else if (!isLoading) {
            @if (chatStatus === '' && searchQuery === '') {
                <div class="text-center no-conversations">
                    <img src="../../assets/messaging/ic_no_conversations.svg" />
                    <h6>No conversations</h6>
                    <span>There are currently no conversations between you and your clients.</span>
                </div>
            } @else {
                <div class="text-center no-conversations">
                    <img src="../../assets/messaging/ic_no_conversations.svg" />
                    <h6>No conversations found</h6>
                    <span>We couldn't find any conversations. Please try searching with a different term.</span>
                </div>
            }
        }
    </div>
</ng-template>

<!-- for media -->
<ng-template #userList let-offcanvas>
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">User List</h5>
        <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        (click)="offcanvas.close('Close click')"
        ></button>
    </div>
    
    <div class="offcanvas-body p-0">
        <ng-container *ngTemplateOutlet="chatList"></ng-container>
    </div>
</ng-template>

<ng-template #userInfo let-offcanvas>
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">User Info</h5>
        <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        (click)="offcanvas.close('Close click')"
        ></button>
    </div>
    
    <div class="offcanvas-body p-0">
        <div class="chat-user_info">
        <div class="text-center card-body position-relative pb-0">
            <ng-container *ngTemplateOutlet="getUserInfo"></ng-container>
        </div>
        <div class="card">
            <ng-container *ngTemplateOutlet="personalDetails"></ng-container>
        </div>
        </div>
    </div>
</ng-template>

<ng-template #getUserInfo>
    <div class="chat-avatar d-inline-flex mx-auto">
        <img class="rounded-circle img-fluid wid-100" src="{{ getUser.avatar }}" alt="User image" />
    </div>
    
    <h5 class="mb-0">{{ getUser.name }}</h5>
    
    <p class="text-muted text-sm">{{ getUser.status }}</p>
    
    <div class="d-flex align-items-center justify-content-center mb-4">
        @if (getUser.online_status === 'available') {
        <i class="text-success me-2" antIcon type="check-circle" theme="fill"></i>
        <span class="badge bg-light-success text-capitalize">{{ getUser.online_status }}</span>
        } @else if (getUser.online_status === 'do_not_disturb') {
        <i class="text-secondary me-2" antIcon type="minus-circle" theme="fill"></i>
        <span class="badge bg-light-secondary text-capitalize">{{ getUser.online_status }}</span>
        } @else if (getUser.online_status === 'offline') {
        <i class="text-warning me-2" antIcon type="clock-circle" theme="fill"></i>
        <span class="badge bg-light-warning text-capitalize">{{ getUser.online_status }}</span>
        }
    </div>
    
    <ul class="list-inline ms-auto mb-0">
        @for (task of icon_list; track task) {
        <li class="list-inline-item">
            <a class="avatar avatar-s btn-link-secondary">
            <i class="text-muted f-16" antIcon theme="outline"></i>
            </a>
        </li>
        }
    </ul>
</ng-template>

<ng-template #personalDetails>
    <div>
        <div class="card-body user-all-details">
        <div class="row g-3 mb-3">
            @for (card of cards; track card) {
            <div class="col-6">
                <div class="p-3 rounded {{ card.background }}">
                <p class="mb-1">{{ card.title }}</p>
                <div class="d-flex align-items-center">
                    <i class="{{ card.text_color }} f-16" antIcon theme="outline"></i>
                    <h4 class="mb-0 ms-2">{{ card.amount }}</h4>
                </div>
                </div>
            </div>
            }
        </div>
        
        <a
            class="btn border-0 px-0 text-start w-100"
            data-bs-toggle="collapse"
            (click)="infoCollapsed = !infoCollapsed"
            [attr.aria-expanded]="!infoCollapsed"
        >
            <div class="float-end"><i antIcon type="down" theme="outline"></i></div>
            <h5 class="mb-0">Information</h5>
        </a>
        
        <div class="collapse show">
            <div class="py-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <p class="mb-0">Address</p>
                <p class="mb-0 text-muted">{{ getUser.location }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
                <p class="mb-0">Email</p>
                <p class="mb-0 text-muted">{{ getUser.work_email }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
                <p class="mb-0">Phone</p>
                <p class="mb-0 text-muted">{{ getUser.personal_phone }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
                <p class="mb-0">Last visited</p>
                <p class="mb-0 text-muted">{{ getUser.lastMessage }}</p>
            </div>
            </div>
        </div>
        
        <hr class="my-3" />
        
        <div class="form-check form-switch d-flex align-items-center justify-content-between p-0">
            <label class="form-check-label h5 mb-0" for="customSwitchemlnot1">Notification</label>
            <input class="form-check-input chat h5 mb-0 position-relative" type="checkbox" id="customSwitchemlnot1" checked />
        </div>
        
        <hr class="my-3" />
        <h5 class="mb-3">File type</h5>
        <hr class="my-3" />
        
        @for (task of file; track task) {
            <div class="media align-items-center mb-2">
            <a class="avatar avatar-s {{ task.background }}">
                <i antIcon theme="outline"></i>
            </a>
            <div class="media-body ms-3">
                <h6 class="mb-0">{{ task.title }}</h6>
                <span class="text-muted text-sm">{{ task.text }}</span>
            </div>
            <a class="avatar avatar-xs btn-link-secondary" href="javascript:">
                <i antIcon type="right" theme="outline"></i>
            </a>
            </div>
        }
        </div>
    </div>
</ng-template>

<!-- Filters Modal -->
<div class="modal fade" 
     [class.show]="showFiltersModal" 
     [style.display]="showFiltersModal ? 'block' : 'none'"
     tabindex="-1" 
     role="dialog"
     (click)="cancelFilters()"
     *ngIf="showFiltersModal">
    <div class="modal-dialog modal-dialog-top" 
         role="document"
         (click)="$event.stopPropagation()">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Select filters</h5>
                <button type="button" 
                        class="btn-close" 
                        (click)="cancelFilters()"
                        aria-label="Close">
                    <img src="assets/common/ic_x_s_size.svg" alt="" />
                </button>
            </div>
            <div class="modal-body">
                @for (tagList of userTagLists; track tagList.name) {
                    @if (tagList.label !== 'user_status' && tagList.tags && tagList.tags.length > 0) {
                        <div class="filter-section mb-4">
                            <h6 class="filter-section-title mb-2">{{ tagList.name }}</h6>
                            <div class="user-tags gap-2">
                                @for (tag of tagList.tags; track tag.id) {
                                    <button type="button"
                                            class="btn button-tag-pill"
                                            [class.tag-pill-selected]="isTagSelected(tag.id)"
                                            (click)="toggleTagSelection(tag.id)">
                                        <img src="assets/common/ic_tag.svg" alt="tag" class="tag-icon">
                                        {{ tag.name }}
                                    </button>
                                }
                            </div>
                        </div>
                    }
                }
            </div>
            <div class="modal-footer">
                <button type="button" 
                        class="btn btn-outline-secondary" 
                        (click)="cancelFilters()">
                    Cancel
                </button>
                <button type="button" 
                        class="btn btn-primary" 
                        (click)="applyFilters()">
                    Apply filters
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade" 
     [class.show]="showFiltersModal"
     *ngIf="showFiltersModal"></div>
